import { UIText1 } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './FullscreenGalleryHeader.css';
import { DownloadIcon } from './icons';
import { ChatPrettyDate } from '../ChatPrettyDate';

interface IFullscreenGalleryHeaderProps {
  src: string;
  created: number | null;
  handleClose: () => void;
  handleSave: () => void;
}

export const FullscreenGalleryHeader: React.FC<IFullscreenGalleryHeaderProps> = ({
  src,
  created,
  handleClose,
  handleSave,
}) => {
  return (
    <div className={styles['container']} data-testid="FullscreenGalleryHeader">
      {created && (
        <div className={styles['date_block']} data-testid="FullscreenGalleryHeaderDate">
          <UIText1 color="text-inverted-default">
            <ChatPrettyDate
              date={created}
              showTime
              containerStyles={{ fontSize: 'inherit', lineHeight: 'inherit', color: 'inherit' }}
            />
          </UIText1>
        </div>
      )}
      <div className={styles['buttons_block']}>
        <a href={src} download onClick={handleSave} data-testid="FullscreenGalleryHeaderSaveButton">
          <DownloadIcon />
        </a>
        <div onClick={handleClose} className={styles['close_button']} data-testid="FullscreenGalleryHeaderCloseButton">
          <IconActionClose16 color="icon-inverted-default" />
        </div>
      </div>
    </div>
  );
};
